export enum DATA_QA {
  ROOT = 'start-and-end-time',
  START_TIME_SELECT = 'start-and-end-time__start-time-select',
  END_TIME_SELECT = 'start-and-end-time__end-time-select',
  LAUNCH_NOW = 'start-and-end-time__launch-now',
  SCHEDULED_START = 'start-and-end-time__scheduled-start',
}
